import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { safeGet, safeGetWithType } from 'iotera-base/json';
import { isEmpty, isInteger } from 'iotera-base/object';
import Result from 'iotera-base/result';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { domainIsTenant as dit } from '../../../../routes/routes';

import moment from 'moment';

import fileDownload from 'js-file-download';
import { CustomTableCell, TablePaginationActionsWrapped } from '../../../../custom/table';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../../../lib/components/callbackGlobal';
import { lowercaseSpaceReplace, toDate } from '../../../../lib/components/formatter';
import { getWidthColumnByPercent } from '../../../../lib/components/function';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import MoreIcon from '@material-ui/icons/MoreHoriz';
import TableIcon from '@material-ui/icons/TableChart';

import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';


import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import RefreshIcon from '@material-ui/icons/Refresh';

import { SizeMe } from 'react-sizeme';
import { Card, CardBody } from 'reactstrap';

import { SubViewHeader } from '../../../../lib/components/subHeader';

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

import { capitalize } from 'lodash';

import Tabs from 'react-responsive-tabs';

import { buildWBoundActions, buildWSelector } from '../../../../redux/ducks';
import { actions as notificationActions } from '../../../../redux/ducks/notification';

import { DateRangePicker } from 'react-dates';
import {
  Transition, formatDate,
} from '../../data/detail/function';

import TabDateTime from './tab-date-time';
import TabLatest from './tab-latest';

import { ioteraConfirmAlert } from '../../../../lib/components/react/react-confirm-alert';

// function render tabs
const getTabs = (dataTabs) => {
    return dataTabs.map((dataTab, i) => ({
      title: safeGet(dataTab, 'titleTabs'),
      getContent: () => safeGet(dataTab, 'contentTabs'),
      key: i,
      tabClassName: '',
      panelClassName: ''
    }))
  }

const STATE_DATA = 'STATE_DATA';
const STATE_DATA_RPAYLOAD = 'STATE_DATA_rpayload'
const DOWNLOAD_STATE_TIME = 'DOWNLOAD_STATE_TIME';
const DOWNLOAD_STATE_NLATEST = 'DOWNLOAD_STATE_NLATEST';
const DELETE_STATE = 'DELETE_STATE';
const WKEY = 'STATE_DATA';

const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

class StateDataTab extends Component {
    constructor(props) {
      super(props)
      const selected = safeGetWithType(this, ['props', 'selected'], {});
      const key = safeGetWithType(selected, ['key'], '');
      const deviceId = safeGetWithType(this, ['props', 'match', 'params', 'id'], '');
      this.state = {
        deviceId,
        key,
        loading: true,
        refresh: false,
      }
      this.handleRefresh = this.handleRefresh.bind(this);
      this.handleCbRefresh = this.handleCbRefresh.bind(this);
      this.handleLoading = this.handleLoading.bind(this);
    }
  
    handleRefresh() {
      const _this = this
      _this.setState({
        refresh: true
      })
    }
  
    handleCbRefresh(state) {
      this.setState({
        refresh: state
      })
    }
  
    handleLoading(state) {
      this.setState({
        loading: state
      })
    }
  
    render() {
      const _this = this
      const _props = _this.props
      const _state = _this.state
      const { key, loading, refresh } = _state
      let { datatype } = _state;
      datatype = capitalize(datatype)
      let dataTabs = [
        {
          'titleTabs': 'Nilai Terakhir',
          'contentTabs': <TabLatest {..._props} refresh={refresh} cbLoading={_this.handleLoading} cbRefresh={_this.handleCbRefresh} />
        },
        {
          'titleTabs': 'Waktu',
          'contentTabs': <TabDateTime {..._props} refresh={refresh} cbLoading={_this.handleLoading} cbRefresh={_this.handleCbRefresh} />
        }
      ]
      const spinner =
        <div className='centeringItem'>
          <ReactLoading type='spinningBubbles' color='#000' />
        </div>
      return (
        <Dialog
          fullScreen
          open={_props.dialogOpen}
          onClose={_props.handleClose}
          TransitionComponent={Transition}
        >
          <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
            <AppBar style={{ position: 'relative' }}>
              <Toolbar>
                <IconButton color="inherit" onClick={_props.handleClose} aria-label="Close">
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6" color="inherit" style={{ flex: 1 }}>
                  Data {datatype}
                </Typography>
                <IconButton color="inherit" onClick={_this.handleRefresh} aria-label="Close">
                  <RefreshIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <div className="view">
              <div className="view-content-dashboard">
                <div className="d-flex justify-content-end py-0 margin-scp-data-detail">
                  <div className="font-weight-semi-bold px-0">
                    <span>
                      {'key :​'}&nbsp;
                    </span>
                    <span style={{ color: '#7E57C2', textAlign: 'center' }}>
                      {key}
                    </span>
                  </div>
                </div>
                <Tabs items={getTabs(dataTabs)} showInkBar />
              </div>
            </div>
          </Loader>
        </Dialog>
      )
    }
  }

class DeviceState extends Component {
    constructor(props) {
      super(props);
      moment.locale('id');
      let today = moment();
      let lastMonth = moment().subtract(1, 'months');
      this.state = {
        navMini: false,
        loading: true,
        page: 0,
        rowsPerPage: 100,
        dropdownOpen: {},
        dialogOpen: false,
        dialogInputOpen: false,
        dialogDownload: false,
        dialogUObject: false,
        dialogPolicy: false,
        dialogTag: false,
        selectedItem: {},
        selectedKey: '',
        downloadMethod: 'time',
        nData: 50,
        startDate: lastMonth,
        endDate: today,
        isDownloadable: true,
        valueInput: null,
        formData: {},
        dataUObject: {}
      };
      this.onMouseEnter = this.onMouseEnter.bind(this);
      this.onMouseLeave = this.onMouseLeave.bind(this);
      this.handleClickOpen = this.handleClickOpen.bind(this);
      this.handleClickDownload = this.handleClickDownload.bind(this);
      this.handleClickDelete = this.handleClickDelete.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.handleClickOpenInput = this.handleClickOpenInput.bind(this);
      this.handleCloseInput = this.handleCloseInput.bind(this);
      this.onChangeDate = this.onChangeDate.bind(this);
      this.handleChangeMethod = this.handleChangeMethod.bind(this);
      this.handleChangeNData = this.handleChangeNData.bind(this);
      this.selectionFormData = this.selectionFormData.bind(this);
    }
  
    handleExpandNode = () => false
  
    onChangeDate(date) {
      let startDate = safeGet(date, ['startDate'])
      let endDate = safeGet(date, ['endDate'])
      let isDownloadable;
      if (startDate !== null && endDate !== null && startDate !== undefined && endDate !== undefined) {
        isDownloadable = true;
      } else {
        isDownloadable = false;
      }
      this.setState({ startDate: date.startDate, endDate: date.endDate, isDownloadable })
    }
  
    handleChangeInput = (item) => event => {
      const _this = this
      let datatype = safeGet(item, ['datatype'])
      if (datatype === 'uobject' || datatype === 'object') {
        _this.setState({ formData: event.formData })
      }
      else {
        _this.setState({ valueInput: event.target.value })
      }
    }
  
    handleChangeToggle = value => {
      this.setState({ valueInput: value })
    }
  
    handleChangeNData = event => {
      let nData = safeGetWithType(event, ['target', 'value'], '50');
      let nDataInt = parseInt(nData, 10)
      let isDownloadable = true;
      if (isNaN(nDataInt)) {
        nDataInt = 0;
        isDownloadable = false;
      } else if ((nDataInt < 1) || (nDataInt > 5000)) {
        isDownloadable = false;
      }
      this.setState({ nData: nDataInt, isDownloadable })
    }
  
    handleChangeMethod = event => {
      let downloadMethod = safeGetWithType(event, ['target', 'value'], 'time');
      this.setState({ downloadMethod })
    }
  
    handleClickOpenInput = (key, selectedItem) => () => {
      const _this = this
      const _state = _this.state
      let dropdownOpen = Object.assign({}, _state.dropdownOpen);
      // set dropdown hidden 
      dropdownOpen[key] = false;
      this.setState({ dropdownOpen, dialogInputOpen: true, selectedItem, selectedKey: key });
    };
  
    handleClickDownload = (key, selectedItem) => () => {
      const _this = this
      const _props = _this.props
      const _state = _this.state
      let dropdownOpen = Object.assign({}, _state.dropdownOpen);
      dropdownOpen[key] = false;
      _this.setState({ dropdownOpen, dialogDownload: true, selectedItem, selectedKey: key });
    };

    handleClickDelete = (key, selectedItem) => () => {
      const _props = this.props;
      const deviceId = safeGet(_props, ['match', 'params', 'id']);
      console.log(selectedItem);
      console.log(deviceId);

      ioteraConfirmAlert(
        'Konfirmasi Hapus State',
        'Apakah anda yakin ingin menghapus state?',
        null,
        () => {
          _props.wSingleRequestCall({
            id: DELETE_STATE,
            body: {
              device_id: deviceId,
              key: selectedItem.key 
            }
          });
        },
        null,
        null
      )
    };
  
    handleCloseDownload = () => {
      this.setState({ dropdownOpen: {}, dialogDownload: false, selectedKey: '', selectedItem: {} });
    };
  
    handleSubmitDownload = (_this) => () => {
      const _this = this
      const _props = _this.props
      const _state = _this.state
      const deviceId = safeGetWithType(_props, ['match', 'params', 'id'], '');
      if (deviceId === '') {
        return;
      }
      let startDate = safeGet(_state, ['startDate']);
      let endDate = safeGet(_state, ['endDate']);
      startDate = startDate.valueOf();
      endDate = endDate.valueOf();
      let sensor = safeGetWithType(_state, ['selectedItem', 'sensor'], '');
      let configtype = safeGetWithType(_state, ['selectedItem', 'configtype'], '');
      let param = safeGetWithType(_state, ['selectedItem', 'param'], '');
      let downloadMethod = safeGetWithType(_state, ['downloadMethod'], 'time');
      let ndata = safeGetWithType(_state, ['nData'], 50);
      
      if (downloadMethod === 'time') {
        _props.wSingleRequestCall({
          id: DOWNLOAD_STATE_TIME,
          params: {
            device_id: deviceId,
            start: startDate,
            end: endDate,
            sensor,
            configtype,
            param
          }
        });
      } else if (downloadMethod === 'ndata') {
        _props.wSingleRequestCall({
          id: DOWNLOAD_STATE_NLATEST,
          params: {
            device_id: deviceId,
            sensor,
            configtype,
            param,
            ndata
          }
        });
      }

      _this.setState({ dropdownOpen: {}, dialogDownload: false, loading: true });
    }
  
    handleCloseInput = () => {
      this.setState({ dropdownOpen: {}, dialogInputOpen: false, selectedKey: '', selectedItem: {}, valueInput: null, formData: {} });
    };
  
    handleClickOpen = (key, selectedItem) => () => {
      const _this = this
      const _state = _this.state
      const dropdownOpen = Object.assign({}, _state.dropdownOpen);
      dropdownOpen[key] = false;
      _this.setState({ dropdownOpen, dialogOpen: true, selectedItem });
    }
  
    handleClickPolicy = (key, selectedItem) => () => {
      const _this = this
      const _state = _this.state
      const dropdownOpen = Object.assign({}, _state.dropdownOpen);
      dropdownOpen[key] = false;
      _this.setState({ dropdownOpen, dialogPolicy: true, selectedItem });
    }
  
    handleClose = () => {
      this.setState({ dialogOpen: false });
    };
  
    handleChangePage = (event, page) => {
      this.setState({ page });
    };
  
    handleChangeRowsPerPage = event => {
      let rowsPerPage = event.target.value;
      if (!isInteger(rowsPerPage))
        rowsPerPage = parseInt(rowsPerPage)
      this.setState({ page: 0, rowsPerPage });
    };
  
    onMouseEnter = (key) => () => {
      const _this = this
      const _state = _this.state
      let dropdownOpen = Object.assign({}, _state.dropdownOpen);
      // set dropdown visible 
      dropdownOpen[key] = true;
      _this.setState({ dropdownOpen });
    }
  
    onMouseLeave = (key) => () => {
      const _this = this
      const _state = _this.state
      let dropdownOpen = Object.assign({}, _state.dropdownOpen);
      // set dropdown hidden 
      dropdownOpen[key] = false;
      _this.setState({ dropdownOpen });
    }
  
    selectionFormData(item, formData) {
      let dataToShow = {}
      if (!isEmpty(formData)) {
        dataToShow = formData
      }
      else {
        if (!isEmpty(item)) {
          dataToShow = item
        }
      }
      return dataToShow
    }

    componentDidMount() {
      const _this = this
      const _props = _this.props
      const _state = _this.state
      const deviceId = safeGet(_props, ['match', 'params', 'id']);
      const domainIsTenant = dit(_props);
      // callback global
      setCallbackGlobal(_props)
      _props.wSetConfig({
        single_config: {
          [DOWNLOAD_STATE_TIME]: {
            wparam: {
              ...domainIsTenant,
              responseType: 'text',
              path: '/fetch/web/file/csv/period/' + deviceId,
              timeout: 60000
            },
            wcallback: {
              finished: function (id, result) {
                if (result.code === Result.HTTP.OK) {
                  const deviceInfo = safeGet(_this, ['props', 'items', STATE_DATA_RPAYLOAD])
                  let devName = safeGet(deviceInfo, ['device_label'], 'Data_perangkat');
                  devName = lowercaseSpaceReplace(devName)
                  let devId = safeGet(deviceInfo, ['device_id'], '');
                  if (devId !== '') {
                    devId = '_' + devId
                  }
                  let selected = safeGetWithType(_state, ['selectedItem'], {})
                  let sensor = safeGetWithType(selected, ['sensor'], '');
                  if (sensor !== '') {
                    sensor = '_' + sensor
                  }
                  let configtype = safeGetWithType(selected, ['configtype'], '');
                  if (configtype !== '') {
                    configtype = '_' + configtype
                  }
                  let param = safeGetWithType(selected, ['param'], '');
                  if (param !== '') {
                    param = '_' + param
                  }
  
                  let now = moment().unix() * 1000;
                  let nowString = toDate(now, 'YYYYMMDD_HHmmss')
                  let fileName = devName + '_' + nowString + devId + sensor + configtype + param + '.csv';
                  let csvDataString = safeGetWithType(result, ['body'], '');
                  _props.showSingleNotification({ message: 'Download sedang dilakukan', position: 'tr', level: 'info' });
                  _this.setState({
                    loading: false,
                  })
                  return fileDownload(csvDataString, fileName);
                } else {
                  _props.showSingleNotification({ message: 'Download gagal', position: 'tr', level: 'error' });
                  _this.setState({
                    loading: false,
                  })
                }
              }
            }
          },
          [DOWNLOAD_STATE_NLATEST]: {
            wparam: {
              ...domainIsTenant,
              responseType: 'text',
              path: '/fetch/web/file/csv/nlatest/' + deviceId,
              timeout: 60000
            },
            wcallback: {
              finished: function (id, result) {
                if (result.code === Result.HTTP.OK) {
                  const deviceInfo = safeGet(_this, ['props', 'items', STATE_DATA_RPAYLOAD])
                  let devName = safeGet(deviceInfo, ['device_label'], 'Data_perangkat');
                  devName = lowercaseSpaceReplace(devName)
                  let devId = safeGet(deviceInfo, ['device_id'], '');
                  if (devId !== '') {
                    devId = '_' + devId
                  }
                  let selected = safeGetWithType(_state, ['selectedItem'], {})
                  let sensor = safeGetWithType(selected, ['sensor'], '');
                  if (sensor !== '') {
                    sensor = '_' + sensor
                  }
                  let configtype = safeGetWithType(selected, ['configtype'], '');
                  if (configtype !== '') {
                    configtype = '_' + configtype
                  }
                  let param = safeGetWithType(selected, ['param'], '');
                  if (param !== '') {
                    param = '_' + param
                  }
                  let now = moment().unix() * 1000;
                  let nowString = toDate(now, 'YYYYMMDD_HHmmss')
                  let fileName = devName + '_' + nowString + devId + sensor + configtype + param + '.csv';
                  let csvDataString = safeGetWithType(result, ['body'], '');
                  _props.showSingleNotification({ message: 'Download sedang dilakukan', position: 'tr', level: 'info' });
                  _this.setState({
                    loading: false,
                  })
                  return fileDownload(csvDataString, fileName);
                } else {
                  _props.showSingleNotification({ message: 'Download gagal', position: 'tr', level: 'error' });
                  _this.setState({
                    loading: false,
                  })
                }
              }
            }
          },
          [DELETE_STATE]: {
            wparam: {
              ...domainIsTenant,
              method: 'POST',
              path: '/service/web/state/delete',
            },
            wcallback: {
              started: function (id, result) {
                _this.setState({
                  loading: true,
                })
              },
              finished: function (id, result) {
                _this.setState({
                  loading: false,
                })
              }
            }
          }
        },
        background_config: {
          [STATE_DATA]: {
            wparam: {
              ...domainIsTenant,
              path: '/service/web/state/list/device',
              params : {
                device_id: deviceId
              }
            },
            wcallback: {
              finished: function (id, result) {
                _this.setState({
                  loading: false,
                })
                return result
              }
            }
          }
        }
      });
    }
  
    componentWillUnmount() {
      const _props = this.props
      // callback global
      unsetCallbackGlobal(_props)
      _props.wUnsetConfig({ key: WKEY });
    }
  
    render() {
      const _this = this
      const _props = _this.props
      const _state = _this.state
      const data = safeGetWithType(_props, ['items', STATE_DATA_RPAYLOAD, 'states'], []);
      const title = 'Daftar Kondisi'
      const subTitle = ''
      const { rowsPerPage, page, loading, dialogOpen, selectedItem } = _state;
      const spinner =
        <div className='centeringItem'>
          <ReactLoading type='spinningBubbles' color='#000' />
        </div>
      return (
        <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
          <div className="view">
            <SubViewHeader title={title} subTitle={subTitle} />
            <div className="view-content-dashboard">
              <Card>
                <SizeMe>{({ size }) =>
                  <CardBody >
                    <div className="table-responsive">
                      <Table className="table">
                        <TableHead style={{ height: 0 }}>
                          <TableRow>
                            <CustomTableCell style={{
                              minWidth: getWidthColumnByPercent(10, size.width - 65),
                              maxWidth: getWidthColumnByPercent(10, size.width - 65)
                            }}>key</CustomTableCell>
                            <CustomTableCell style={{
                              minWidth: getWidthColumnByPercent(10, size.width - 65),
                              maxWidth: getWidthColumnByPercent(10, size.width - 65)
                            }}>value</CustomTableCell>
                            <CustomTableCell style={{
                              minWidth: getWidthColumnByPercent(10, size.width - 65),
                              maxWidth: getWidthColumnByPercent(10, size.width - 65)
                            }}>active</CustomTableCell>
                            <CustomTableCell style={{
                              minWidth: getWidthColumnByPercent(15, size.width - 65),
                              maxWidth: getWidthColumnByPercent(15, size.width - 65)
                            }}>initial time</CustomTableCell>
                            <CustomTableCell style={{
                              minWidth: getWidthColumnByPercent(15, size.width - 65),
                              maxWidth: getWidthColumnByPercent(15, size.width - 65)
                            }}>latest time</CustomTableCell>
                            <CustomTableCell style={{
                              textAlign: 'center', minWidth: getWidthColumnByPercent(5, size.width - 65),
                              maxWidth: getWidthColumnByPercent(5, size.width - 65)
                            }}><span>action</span></CustomTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, i) =>
                            <TableRow key={i} className='table-row-child-iotera'>
                              <TableCell >
                                <div style={{ fontWeight: 500 }}>{item.key}</div>
                              </TableCell>
                              <TableCell >
                                <div style={{ fontWeight: 500 }}>{item.value}</div>
                              </TableCell>
                              <TableCell >
                                <div style={{ fontWeight: 500 }}>
                                    <span><span className={!item.is_null ? 'string-iotera-color' : 'number-iotera-color'}>{!item.is_null ? 'Active': 'Inactive'}</span></span>
                                </div>
                              </TableCell>
                              <TableCell >
                                <Tooltip title={item.initial_ts != null ? item.initial_ts : ""} leaveDelay={500} interactive><span>{formatDate(item.initial_ts != null, item.initial_ts)}</span></Tooltip>
                              </TableCell>
                              <TableCell >
                                <Tooltip title={item.latest_ts != null ? item.latest_ts : ""} leaveDelay={500} interactive><span>{formatDate(item.latest_ts != null, item.latest_ts)}</span></Tooltip>
                              </TableCell>
                              <TableCell style={{ textAlign: 'center' }} onMouseLeave={_this.onMouseLeave(i)}>
                                <UncontrolledDropdown isOpen={safeGetWithType(_state, ['dropdownOpen', i], false)} >
                                  <DropdownToggle tag="div">
                                    <IconButton onMouseOver={_this.onMouseEnter(i)} style={{ cursor: 'pointer', padding: 4 }}>
                                      <MoreIcon color="inherit" style={{ height: 30, width: 30 }} />
                                    </IconButton>
                                  </DropdownToggle>
                                  <DropdownMenu style={{ padding: 0, margin: 0 }}>
                                    <DropdownItem style={{ margin: 0 }} onClick={_this.handleClickOpen(i, item)}>
                                      <TableIcon color="inherit" style={{ height: 18, width: 18 }} />&emsp;
                                      <span style={{ marginRight: 20 }}>Lihat State</span>
                                    </DropdownItem>
                                    <DropdownItem style={{ margin: 0 }} onClick={_this.handleClickDownload(i, item)}>
                                      <DownloadIcon color="inherit" style={{ height: 18, width: 18 }} />&emsp;
                                      <span style={{ marginRight: 20 }}>Download</span>
                                    </DropdownItem>
                                    <DropdownItem style={{ margin: 0 }} onClick={_this.handleClickDelete(i, item)}>
                                      <DeleteIcon color="inherit" style={{ height: 18, width: 18 }} />&emsp;
                                      <span style={{ marginRight: 20 }}>Hapus</span>
                                    </DropdownItem>
                                  </DropdownMenu>
                                  {i === _state.selectedKey ?
                                    <Dialog
                                      open={_state.dialogDownload}
                                      onClose={_this.handleCloseDownload}
                                      aria-labelledby="max-width-dialog-title"
                                      fullWidth={true}
                                      maxWidth={'md'}
                                    >
                                      <DialogTitle id="form-dialog-title">Download Data</DialogTitle>
                                      <DialogContent style={{ minHeight: '500px', minWidth: '800px', maxWidth: '800px' }}>
                                        <DialogContentText>
                                          {'Jumlah data yang didownload berdasarkan'}
                                        </DialogContentText>
                                        <RadioGroup
                                          aria-label="Jumlah data yang didownload berdasarkan"
                                          name="Jumlah data yang didownload berdasarkan"
                                          value={_state.downloadMethod}
                                          row
                                          onChange={(e) => _this.handleChangeMethod(e)}
                                        >
                                          <FormControlLabel value="time"
                                            control={<Radio color="primary" />} label="Waktu" />
                                          <FormControlLabel value="ndata"
                                            control={<Radio color="primary" />} label="Jumlah Data Terakhir" />
                                        </RadioGroup>
                                        {
                                          _state.downloadMethod === 'time' ?
                                            <div>
                                              <DialogContentText>
                                                {
                                                  'Pilih jangka waktu'
                                                }
                                              </DialogContentText>
                                              <DateRangePicker
                                                startDate={_state.startDate} // momentPropTypes.momentObj or null,
                                                startDateId="start" // PropTypes.string.isRequired,
                                                endDate={_state.endDate} // momentPropTypes.momentObj or null,
                                                endDateId="end" // PropTypes.string.isRequired,
                                                isOutsideRange={() => false}
                                                startDatePlaceholderText="awal"
                                                endDatePlaceholderText="akhir"
                                                onDatesChange={({ startDate, endDate }) =>
                                                  _this.onChangeDate({ startDate, endDate })} // PropTypes.func.isRequired,
                                                focusedInput={_state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                                onFocusChange={focusedInput =>
                                                  _this.setState({ focusedInput })} // PropTypes.func.isRequired,
                                                small={true}
                                                styles={{ border: '0px solid transparent', zIndex: 1400 }}
                                              />
                                            </div>
                                            :
                                            <TextField
                                              autoFocus
                                              margin="dense"
                                              id="name"
                                              label="Jumlah data"
                                              type="number"
                                              InputLabelProps={{
                                                shrink: true,
                                              }}
                                              defaultValue={_state.nData}
                                              fullWidth
                                              onChange={_this.handleChangeNData}
                                            />
                                        }
                                      </DialogContent>
                                      <DialogActions>
                                        <Button onClick={_this.handleCloseDownload} color="primary">
                                          Batal
                                        </Button>
                                        <Button disabled={!_state.isDownloadable} onClick={_this.handleSubmitDownload(_this)}
                                          variant="contained" color="primary">
                                          Simpan
                                        </Button>
                                      </DialogActions>
                                    </Dialog>
                                    :
                                    null}
                                </UncontrolledDropdown>
                              </TableCell>
                            </TableRow>)}
                          {dialogOpen ?
                            <StateDataTab {..._props} dialogOpen={dialogOpen} handleClose={_this.handleClose}
                              selected={selectedItem} />
                            : null
                          }
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              labelDisplayedRows={({ from, to, count }) => `${from}-${to} dari ${count}`}
                              labelRowsPerPage='Baris terlihat:'
                              rowsPerPageOptions={[100, 150, 200]}
                              count={data.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                native: true,
                              }}
                              onPageChange={_this.handleChangePage}
                              onChangeRowsPerPage={_this.handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActionsWrapped}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </div>
                  </CardBody>
                }</SizeMe>
              </Card>
            </div>
          </div >
        </Loader >
      );
    }
  }


  const mapStateToProps = function (state) {
    return {
      items: wSelector.getMappedState(state)
    }
  }
  
  const mapDispatchToProps = function (dispatch) {
    return {
      ...wBoundActions(dispatch),
      ...bindActionCreators(notificationActions, dispatch)
    }
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DeviceState));